(function () {
    "use strict";
    // @ngInject
    function EventFormControllerCtor($scope, $element, $attrs, DeviceService,
                                     AnalyticsService, moment, $translate, EventsManager, TimezoneService, CompaniesManager,
                                     CalendarService, EventService, _, ModalService, UiPersistenceService, WorkflowManager, UsersManager) {

        this.$onInit = function $onInit() {
            // Default values
            this.CalendarService = CalendarService;
            this.AnalyticsService = AnalyticsService;
            this.EventService = EventService;
            this.EventsManager = EventsManager;
            this.TimezoneService = TimezoneService;
            this.ModalService = ModalService;
            this.CompaniesManager = CompaniesManager;
            this.UiPersistenceService = UiPersistenceService;
            this.WorkflowManager = WorkflowManager;
            this.$translate = $translate;
            this.DeviceService = DeviceService;
            this.UsersManager = UsersManager;
            this.user = this.UsersManager.getCurrUser();
            this.currentUserIsVendor = this.user.isVendor();

            this.leadSourcesLimit = 18;

            this._ = _;
            this.showLeadSourceOpenText = false;
            this.creatingNewLeadSource = false;

            this.checkingDate = {'event_date': false, 'event_end_date': false};
            this.collisionEvents = {'event_date': [], 'event_end_date': []};
            this.dateConflict = {'event_date': false, 'event_end_date': false};
            this.errorMessage = '';
            this.proTipBoldText = 'PRO TIP: ';
            this.proTipText = 'Add lead source to your project to get more from your reports';
            this.eventTimeZones = this.TimezoneService.getTimezones();
            this.company = this.CompaniesManager.getCurrCompany();
            if (this.event.event_timezone) {
                this.event_timezone = this.TimezoneService.translateFromServer(this.event.event_timezone);
            } else {
                this.event_timezone = this.TimezoneService.getTimezoneForCompany(this.company);
                this.event.event_timezone = this.TimezoneService.translateToServer(this.event_timezone);
            }

            // workaround for new event, no creator company using curr user data
            var eventTypes = [];
            if (!!this.event.creator && !!this.event.creator.company && !!this.event.creator.company.project_types) {
                eventTypes = this.event.creator.company.sortedProjectTypes();
            } else {
                eventTypes = this.company.sortedProjectTypes();
            }

            this.eventTypes = eventTypes.length > 0 ? eventTypes : [{label: ''}];

            this.leadSources = [];
            if (!!this.event.creator && !!this.event.creator.company && !!this.event.creator.company.lead_sources) {
                this.leadSources = this.event.creator.company.sortedLeadSources();
            } else {
                this.leadSources = this.company.sortedLeadSources();
            }
            //TODO remvoe this after migration
            if (this.leadSources.length === 0) {
                var leadSourceEnumList = angular.copy(this.company.isNonEventType() ? this.EventService.nonEventLeadSourceEnum : this.EventService.eventLeadSourceEnum);
                this.leadSources = this.EventService.getTranslatedLeadSourcesEnum(leadSourceEnumList);
            }
            this.selectedLeadSource = this.EventService.getSelectedEventLeadSource(this.event, this.leadSources);

            // Has user already selected lead source
            if (this.selectedLeadSource.label === 'Unknown' && this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.showLeadSourceProTip, {show: true}).show && this.currentUserIsVendor) {
                this.showLeadSourceProTip = true;
            }
            this.calcLeadSourceOpenTextPlaceholder();
            this.isEventTBD = true;
            this.shouldShowDateConflicts = this.company.isShowDateConflictsAutomationOn();


            // Get selected event type based on event.event_type till register success on this.event fires
            var selectedEvent = _.find(this.eventTypes, function(o) { return o.label === this.event.event_type;}.bind(this));

            this.selectedEventType = selectedEvent || this.eventTypes[0];

            this.showExtraFields = !this.hideDetails;
            this.isEditModeFlag = this.isEditMode === 'true';
            this.showValidDateCheckmark = {'event_date': false, 'event_end_date': false};
            this.formRef = null;
            this.isSubmitted = false;
            this.collisionEventsForPopup = [];

            this.fetchingBookedEvents = true;
            this.bookedEvents = this.CalendarService.getEventsCalendar();
            this.fetchingBookedEvents = false;

            this.isVenue = this.company.isVenue();
            this.isViewOnlyMode = this.event.isViewOnlyMode();
            this.clearCollisionsPopup();

            // HACK: Exposes the directive controller on the parent scope
            // with name eventForm.
            this.eventFormBinding = this;

            // TODO(sean): This should be passed down as an update to the event
            // prop vs having it bind to an outside listener.
            // Use 1-way data-binding
            this.register(this.event, 'success', function handleEventUpdated() {
                this.copyDatePickerValues();
                this.isEventTBD = !this.event.event_date;
                this.event_timezone = this.TimezoneService.translateFromServer(this.event.event_timezone);
                this.eventTypes = this.event.creator.company.sortedProjectTypes();
                this.selectedEventType = this.EventService.getProjectTypeByString(this.event.creator.company, this.event.event_type);
                this.selectedLeadSource = this.EventService.getSelectedEventLeadSource(this.event, this.leadSources);
                this.calcLeadSourceOpenTextPlaceholder();
            }.bind(this));
        };

        this.$onDestroy = function $onDestroy() {
            this.unregister(this.event);
        };

        this.onInputBlur = function (changedProperty, newValue) {
            this.onTextInputBlur({changedProperty: changedProperty});
            this.onTextInputChange(changedProperty, newValue);
            if (changedProperty === 'event lead source open text') {
                this.shouldShowLeadSourceError = false;
            }
        };

        this.onTextInputChange = function onTextInputChange(changedProperty, newValue) {
            this.AnalyticsService.track(this, 'edit event input', {
                changedProperty: changedProperty,
                newValue: newValue,
                isNewEvent: !this.event._id,
                source: this.sourceForAnalytics
            });
        };

        this.$postLink = function $postLink() {
            this.isEventTBD = !this.event.event_date;
            this.copyDatePickerValues();

            // References the angular form object
            this.formRef = $scope.eventForm;
        };

        this.copyDatePickerValues = function copyDatePickerValues() {
            this.event_date_dp_formatted = this.formatForDatePicker(this.event.event_date);
            this.event_end_date_dp_formatted = this.formatForDatePicker(this.event.event_end_date);
        };

        this.isDirty = function isDirty() {
            return this.formRef.$dirty;
        };

        this.isValid = function isValid() {
            return this.formRef.$valid;
        };

        this.setSubmitted = function setSubmitted() {
            this.isSubmitted = true;
        };

        this.setTimeZone = function setTimeZone(eventTimeZone) {
            this.event.event_timezone = this.TimezoneService.translateToServer(eventTimeZone);
            this.onInputBlur('event timezone', eventTimeZone);
        };

        this.setLeadSource = function setLeadSource(leadSource) {
            if (this.selectedLeadSource !== leadSource) {
                this.event.lead_source_open_text = "";
            }
            this.selectedLeadSource = leadSource;
            this.event.lead_source = leadSource.label;

            if (this.selectedLeadSource.label !== 'Unknown') {
                this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.showLeadSourceProTip, {show: false});
                // Update Pro Tip text
                this.proTipBoldText = 'Nicely Done!';
                this.proTipText = '';
            }

            this.calcLeadSourceOpenTextPlaceholder();
            this.onInputBlur('event lead source', leadSource.label);
            this.showLeadSourceAdd();
        };

        this.setEventType = function setEventType(projectType) {
            this.selectedEventType = projectType;
            this.event.event_type = projectType.label;
            this.onInputBlur('event type', projectType.label);
        };

        this.toggleEventTBD = function toggleEventTBD($event) {
            // Prevent the fake checkbox click from bubbling up or firing
            // off any other native browser events
            $event.stopPropagation();
            $event.preventDefault();

            this.isEventTBD = !this.isEventTBD;

            if (this.isEventTBD) {
                this.event.event_date = '';
                this.event.event_time_start = '';

                this.event.event_end_date = '';
                this.event.event_time_end = '';

                this.event_date_dp_formatted = '';
                this.event_end_date_dp_formatted = '';

                this.showValidDateCheckmark.event_date = false;
                this.showValidDateCheckmark.event_end_date = false;

                this.dateError = false;
                this.errorMessage = '';
            }

            this.onChangeDate({changedProperty: 'event start date'});
        };

        this.toggleExtraFields = function toggleExtraFields() {
            this.showExtraFields = !this.showExtraFields;
        };

        this.validateDates = function validateDates() {
            if ( !this.event.event_date || (this.event.event_date && !this.isDateValidForAPI(this.event.event_date)) ) {
                this.dateError = true;
                this.errorMessage = $translate.instant('PROJECT.ERRORS._INVALID_DATE_');
            } else if (this.event.event_end_date && !this.isDateValidForAPI(this.event.event_end_date)) {
                this.dateError = true;
                this.errorMessage = $translate.instant('PROJECT.ERRORS._INVALID_DATE_END_');
            } else if (!this.isDateRangeValid()) {
                this.dateError = true;
                this.errorMessage = $translate.instant('PROJECT.ERRORS._INVALID_DATE_RANGE_');
            } else {
                this.dateError = false;
                this.errorMessage = '';
            }
        };

        this.isDateValidForAPI = function isDateValidForAPI(date) {
            var valid_date = moment(date, ['YYYY-MM-DD'], true).isValid();
            if (valid_date) {

                date = moment(date, ['YYYY-MM-DD'], true);
                if (date.year() >= 2000 && date.year() <= 2100) {
                    return true;
                }
            }

            return false;
        };

        this.isDateRangeValid = function() {
            var rangeIsValid = !this.event.event_end_date ||
                (!!this.event.event_end_date &&
                (moment(this.event.event_date, 'YYYY-MM-DD') <= moment(this.event.event_end_date, 'YYYY-MM-DD')));

            if (rangeIsValid && this.event.event_time_start && this.event.event_time_end &&
                (!this.event.event_end_date ||
                this.event.event_date === this.event.event_end_date)) {

                // check times
                var start = Date.parse('01/01/2011 ' + this.event.event_time_start);
                var end = Date.parse('01/01/2011 ' + this.event.event_time_end);
                if (start > end) {
                    // in case it was empty
                    this.event.event_end_date = this.event.event_date;
                    this.event_end_date_dp_formatted = this.event_date_dp_formatted;
                    return false;
                }
            }

            return rangeIsValid;
        };

        /**
         * Convert the date (DateTime string format) to the
         * mm/dd/yyyy format that the datepicker expects.
         */
        this.formatForDatePicker = function(date) {
            if (!date) {
                return;
            }

            if (moment(date, 'YYYY-MM-DD').isValid()) {
               return moment(date, 'YYYY-MM-DD').format('MMM DD, YYYY');
            } else {
                console.log('invalid format, expected "YYYY-MM-DD" for %s', date);
            }
        };

        /**
         * Convert the date (DateTime string format) to the
         * mm/dd/yyyy format that the datepicker expects.
         */
        this.formatForEventAPI = function(date) {
            if (!date) {
                return null;
            }

            if (moment(date, 'MMM DD, YYYY').isValid()) {
               return moment(date, 'MMM DD, YYYY').format('YYYY-MM-DD');
            } else {
                console.log('invalid format, expected "MM/DD/YYYY" for %s', date);
            }
        };

        this.addEventEndDate = function addEventEndDate() {
            // End date will default same as start date
            this.event.event_end_date = this.event.event_date;
            this.event_end_date_dp_formatted = this.formatForDatePicker(this.event.event_end_date);

            // End time will default to be 3 hours from start time
            if (this.event.event_time_start) {
                this.event.event_time_end = moment(
                    this.event.event_time_start, 'hh:mm a')
                    .add(4, 'hours').format('hh:mm a');
            }
        };

        this.changeStartDate = function changeStartDate() {
            // Don't update if the date input is empty
            if (!this.event_date_dp_formatted) {
                return;
            }

            this.isEventTBD = false;
            this.event.event_date = this.formatForEventAPI(this.event_date_dp_formatted);

            this.validateDates();
            this.collisionEventsForPopup = [];
            this.updateDateConflicts('event_date', this.event.event_date);

            if (!this.dateError) {
                this.onChangeDate({changedProperty: 'event start date'});
                this._getConflicts('event_date');
            }
        };

        this.changeEndDate = function changeEndDate() {
            this.event.event_end_date = this.formatForEventAPI(this.event_end_date_dp_formatted);

            this.validateDates();
            this.collisionEventsForPopup = [];
            this.updateDateConflicts('event_end_date', this.event.event_end_date);

            if (!this.dateError) {
                this.onChangeDate({changedProperty: 'event end date'});
                this._getConflicts('event_end_date');
            }
        };

        this.removeEndDate = function removeEndDate() {
            this.event.event_end_date = '';
            this.event.event_time_end = '';

            this.event_end_date_dp_formatted = '';

            this.validateDates();

            if (!this.dateError) {
                this.onChangeDate({changedProperty: 'event end date'});
                this.updateDateConflicts('event_end_date', this.event.event_end_date);
            }
        };

        this.updateDateConflicts = function updateDateConflicts(type, date) {

            if (!this.shouldShowDateConflicts) {
                return;
            }

            this.showValidDateCheckmark[type] = false;
            this.checkingDate[type] = true;

            var collisions = this.collisionEventsForPopup;
            this.clearCollisionsPopup();

            var isDateValid = this.isDateValidForAPI(date);

            if (isDateValid && (collisions && collisions.length > 0)) {
                this.collisionEvents[type] = collisions;
                this.showDateCollisionModal[type] = true;
                this.dateConflict[type] = true;
            } else {
                this.collisionEvents[type] = [];
                this.dateConflict[type] = false;
                this.showDateCollisionModal[type] = false;
                this.checkingDate[type] = false;
                if (isDateValid) {
                    if (!this.fetchingBookedEvents) {
                        this.showValidDateCheckmark[type] = true;
                    }
                }
            }
        };

        this.calcLeadSourceOpenTextPlaceholder = function calcLeadSourceOpenTextPlaceholder() {
            if (this.selectedLeadSource.label === "Other") {
                this.leadSourceOpenTextPlaceholder = this.$translate.instant('PROJECT.LABELS._LEAD_SOURCE_OTHER_');
            } else {
                this.leadSourceOpenTextPlaceholder = this.$translate.instant('PROJECT.LABELS._LEAD_SOURCE_REFERRAL_');
            }
        };

        this.keyDownStartDate = function keyDownStartDate(event) {
            if (event.keyCode !== 8 && event.keyCode !== 46) {
                event.preventDefault();
            } else {
                this.event.event_date = '';
                this.event_date_dp_formatted = '';
                this.showValidDateCheckmark.event_date = false;
                this.showValidDateCheckmark.event_end_date = false;
                this.validateDates();

                if (!this.dateError) {
                    this.onChangeDate({changedProperty: 'event end date'});
                    this.updateDateConflicts('event_end_date', this.event.event_end_date);
                }
            }
        };

        this.keyDownEndDate = function keyDownEndDate(event) {
            if (event.keyCode !== 8 && event.keyCode !== 46) {
                event.preventDefault();
            } else {
                this.removeEndDate();
            }
        };
    }

    var EventFormController = Class(Controllers.BaseController, {
        constructor: EventFormControllerCtor,

        openSpaces: function openSpaces() {
            this.ModalService.openEventSpaces(this.event).then(function(res) {
                if(res && res.goToCalendar) {
                    this.modalInstance.dismiss();
                }
            }.bind(this));
        },

        clearCollisionsPopup: function clearCollisionsPopup() {
            this.showDateCollisionModal = {'event_date': false, 'event_end_date': false};
        },

        timeChanged: function timeChanged(objectName, objectField) {
            this.validateDates();
            this.onInputBlur(objectName, objectField);
        },

        _getConflicts: function _getConflicts(field) {

            if (!this.shouldShowDateConflicts) {
                return;
            }

            this.EventsManager.getConflictingEventsByDate(this.event).then(function success(conflictingEvents) {
                this.collisionEventsForPopup = conflictingEvents;
                this.updateDateConflicts(field, this.event[field]);
            }.bind(this));
        },


        showLeadSourceAdd: function showLeadSourceAdd() {
            this.shouldShowLeadSourceAdd = this.selectedLeadSource.label === 'Other' && this.leadSources.length <= this.leadSourcesLimit;
            this.shouldShowLeadSourceError = false;
        },

        saveNewLeadSources: function saveNewLeadSources() {
            if (this.event.lead_source_open_text && this.validLeadSource()) {
                this.creatingNewLeadSource = true;
                this.CompaniesManager.createLeadSource(this.company, this.event.lead_source_open_text, this.shouldShowLeadSourcesEditedToast())
                    .then(function success(resp) {
                        this.leadSources = this.company.sortedLeadSources();
                        var selectedLeadSource = this._.find(this.leadSources, {label: this.event.lead_source_open_text});
                        this.setLeadSource(selectedLeadSource);
                        this.showLeadSourceToast = true;
                        this.shouldShowLeadSourceAdd = false;
                    }.bind(this))
                    .finally(function final() {
                        this.creatingNewLeadSource = false;
                    }.bind(this));
            } else {
                this.shouldShowLeadSourceError = true;
            }
        },

        validLeadSource: function validLeadSource() {
            var label = this.event.lead_source_open_text.toLowerCase();
            var matches = this._.filter(this.leadSources, function(e) {
                return e.label.toLowerCase() === label;
            }.bind(this));
            return matches.length === 0;
        },

        shouldShowLeadSourcesEditedToast: function shouldShowLeadSourcesEditedToast() {
            return !this.DeviceService.checkIfMobileSize() && this.event.creator.isCompanyOwner() && this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.showLeadSourceToast, {show: true}).show;
        }
    });

    Components.EventForm = {
        bindings: {
            event: '=',

            onChangeDate: '&',

            onTextInputBlur: '&',

            hideDetails: '@',

            isEditMode: '@',

            sourceForAnalytics: '=',

            // Always show the add button even if the TBD checkbox is checked
            forceShowAddButton: '@',

            // HACK: Exposes the directive controller on the parent scope
            // with name eventForm.
            eventFormBinding: '=',

            // Have to poke this hole down so we can close the parent modal
            // when the form is wrapped inside.
            modalInstance: '=?',

            // Vendor type that opens the modal. As a test for now for interior/web designers
            showSimpleForm: '=?',

            showLeadSourceToast: '='
        },

        controller: EventFormController,
        name: 'hbEventForm',
        templateUrl: 'angular/app/modules/common/ui_components/event/event_form.html',
    };
})();
